import type * as ents from '@attain-apps/entities'
import * as store from '@attain-apps/fe/web/main/lib/store'

import type { State } from './state'

/** Core actions for the Organizations registry feature. */
// NOTE: intentionally missing return type so that type can be inferred
export function getActionsConfig() {
  return {
    bootstrap: store.actions.standalone({
      data: store.actions.Data.asIs<{
        entityId: ents.core.dms.models.Entity.Id
      }>(),
    }),
    dispose: store.actions.standalone({
      data: ({
        all,
        entityId,
      }: ExactlyOneOf<{
        readonly all: true
        readonly entityId: ents.core.dms.models.Entity.Id
      }>) => ({
        all,
        entityId,
      }),
    }),
  } as const satisfies store.actions.Config.Constraint<State>
}
